/**
 * Texte des Wizards „Neue Kampagne“. Jeder Bereich legt `<bereich>.de.ts` und `<bereich>.en.ts` an
 * (Default-Export: flaches Objekt `{ wizKey: 'Text' }`); sie werden in `wizard-de.ts` /
 * `wizard-en.ts` gesammelt und in `src/locales/de.ts` / `en.ts` eingemischt. Getrennte Dateien,
 * damit die deutschen Texte im Start-Bundle nicht die englischen mitziehen.
 */
export type LocaleModules = Record<string, { default: Record<string, string> }>;

export const merge = (modules: LocaleModules): Record<string, string> =>
  Object.assign({}, ...Object.values(modules).map(m => m.default));
